// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ct9kVdatV78GHhK9QiJ54N
// Component: Gi0qYXS_XGO
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import Sidebar from "../../Sidebar"; // plasmic-import: KsLZ7sb8Ji8/component
import TopBar from "../../TopBar"; // plasmic-import: MnkTdPJ0xv/component
import ClientPaymentsCard from "../../ClientPaymentsCard"; // plasmic-import: 3NZNyXM_vN/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_astriusdraft.module.css"; // plasmic-import: ct9kVdatV78GHhK9QiJ54N/projectcss
import sty from "./PlasmicClientInstance.module.css"; // plasmic-import: Gi0qYXS_XGO/css

createPlasmicElementProxy;

export const PlasmicClientInstance__VariantProps = new Array();

export const PlasmicClientInstance__ArgProps = new Array(
  "clientName",
  "clientEmail",
  "amount",
  "dateCreated"
);

const $$ = {};

function PlasmicClientInstance__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <Sidebar
            data-plasmic-name={"sidebar"}
            data-plasmic-override={overrides.sidebar}
            className={classNames("__wab_instance", sty.sidebar)}
          />

          <div className={classNames(projectcss.all, sty.freeBox__rdSj8)}>
            <TopBar
              data-plasmic-name={"topBar"}
              data-plasmic-override={overrides.topBar}
              className={classNames("__wab_instance", sty.topBar)}
              userNameText={"Jones Ferdinand"}
            />

            <div
              data-plasmic-name={"vertStack"}
              data-plasmic-override={overrides.vertStack}
              className={classNames(projectcss.all, sty.vertStack)}
            >
              <p.Stack
                as={"div"}
                hasGap={true}
                className={classNames(projectcss.all, sty.freeBox__t4Qq)}
              >
                <div
                  data-plasmic-name={"title"}
                  data-plasmic-override={overrides.title}
                  className={classNames(projectcss.all, sty.title)}
                >
                  {p.renderPlasmicSlot({
                    defaultContents: "Nike",
                    value: args.clientName,
                    className: classNames(sty.slotTargetClientName)
                  })}
                </div>
                <div
                  data-plasmic-name={"title2"}
                  data-plasmic-override={overrides.title2}
                  className={classNames(projectcss.all, sty.title2)}
                >
                  {p.renderPlasmicSlot({
                    defaultContents: "john@nike.com",
                    value: args.clientEmail,
                    className: classNames(sty.slotTargetClientEmail)
                  })}
                </div>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__igxHt
                  )}
                >
                  {"Spent:"}
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__l6M8E)}>
                  {p.renderPlasmicSlot({
                    defaultContents: "$1040.00",
                    value: args.amount,
                    className: classNames(sty.slotTargetAmount)
                  })}
                </div>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text___9I5DM
                  )}
                >
                  {"Created:"}
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__x1XcI)}>
                  {p.renderPlasmicSlot({
                    defaultContents: "Dec. 28th, 12:25 AM",
                    value: args.dateCreated,
                    className: classNames(sty.slotTargetDateCreated)
                  })}
                </div>
                <div
                  data-plasmic-name={"editClient"}
                  data-plasmic-override={overrides.editClient}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.editClient
                  )}
                >
                  {"Edit Client"}
                </div>
              </p.Stack>
              <div className={classNames(projectcss.all, sty.freeBox___4YduE)}>
                <div
                  data-plasmic-name={"title9"}
                  data-plasmic-override={overrides.title9}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.title9
                  )}
                >
                  {"Notes"}
                </div>
                <div
                  data-plasmic-name={"rectangle50"}
                  data-plasmic-override={overrides.rectangle50}
                  className={classNames(projectcss.all, sty.rectangle50)}
                >
                  <textarea
                    data-plasmic-name={"paymentNotes"}
                    data-plasmic-override={overrides.paymentNotes}
                    className={classNames(
                      projectcss.all,
                      projectcss.textarea,
                      sty.paymentNotes
                    )}
                    ref={ref => {
                      $refs["paymentNotes"] = ref;
                    }}
                    value={"This is a text area."}
                  />
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__caPz6)}>
                  <div
                    data-plasmic-name={"title12"}
                    data-plasmic-override={overrides.title12}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title12
                    )}
                  >
                    {"Payments"}
                  </div>
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__xIvgb)}>
                  <div
                    data-plasmic-name={"title13"}
                    data-plasmic-override={overrides.title13}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title13
                    )}
                  >
                    {"Amount"}
                  </div>
                  <div
                    data-plasmic-name={"title14"}
                    data-plasmic-override={overrides.title14}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title14
                    )}
                  >
                    {"Status"}
                  </div>
                  <div
                    data-plasmic-name={"title15"}
                    data-plasmic-override={overrides.title15}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title15
                    )}
                  >
                    {"Type"}
                  </div>
                  <div
                    data-plasmic-name={"title16"}
                    data-plasmic-override={overrides.title16}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title16
                    )}
                  >
                    {"Date"}
                  </div>
                </div>
                <p.Stack
                  as={"div"}
                  data-plasmic-name={"paymentsStack"}
                  data-plasmic-override={overrides.paymentsStack}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.paymentsStack)}
                >
                  <ClientPaymentsCard
                    className={classNames(
                      "__wab_instance",
                      sty.clientPaymentsCard___6PVod
                    )}
                  />

                  <ClientPaymentsCard
                    className={classNames(
                      "__wab_instance",
                      sty.clientPaymentsCard___03W7
                    )}
                  />
                </p.Stack>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "sidebar",
    "topBar",
    "vertStack",
    "title",
    "title2",
    "editClient",
    "title9",
    "rectangle50",
    "paymentNotes",
    "title12",
    "title13",
    "title14",
    "title15",
    "title16",
    "paymentsStack"
  ],

  sidebar: ["sidebar"],
  topBar: ["topBar"],
  vertStack: [
    "vertStack",
    "title",
    "title2",
    "editClient",
    "title9",
    "rectangle50",
    "paymentNotes",
    "title12",
    "title13",
    "title14",
    "title15",
    "title16",
    "paymentsStack"
  ],

  title: ["title"],
  title2: ["title2"],
  editClient: ["editClient"],
  title9: ["title9"],
  rectangle50: ["rectangle50", "paymentNotes"],
  paymentNotes: ["paymentNotes"],
  title12: ["title12"],
  title13: ["title13"],
  title14: ["title14"],
  title15: ["title15"],
  title16: ["title16"],
  paymentsStack: ["paymentsStack"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicClientInstance__ArgProps,
          internalVariantPropNames: PlasmicClientInstance__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicClientInstance__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicClientInstance";
  } else {
    func.displayName = `PlasmicClientInstance.${nodeName}`;
  }
  return func;
}

export const PlasmicClientInstance = Object.assign(
  // Top-level PlasmicClientInstance renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    sidebar: makeNodeComponent("sidebar"),
    topBar: makeNodeComponent("topBar"),
    vertStack: makeNodeComponent("vertStack"),
    title: makeNodeComponent("title"),
    title2: makeNodeComponent("title2"),
    editClient: makeNodeComponent("editClient"),
    title9: makeNodeComponent("title9"),
    rectangle50: makeNodeComponent("rectangle50"),
    paymentNotes: makeNodeComponent("paymentNotes"),
    title12: makeNodeComponent("title12"),
    title13: makeNodeComponent("title13"),
    title14: makeNodeComponent("title14"),
    title15: makeNodeComponent("title15"),
    title16: makeNodeComponent("title16"),
    paymentsStack: makeNodeComponent("paymentsStack"),
    // Metadata about props expected for PlasmicClientInstance
    internalVariantProps: PlasmicClientInstance__VariantProps,
    internalArgProps: PlasmicClientInstance__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicClientInstance;
/* prettier-ignore-end */
